















import {
  Component, Mixins,
  Vue,
} from 'vue-property-decorator';
import CheckForUpdates from '@/mixins/checkForUpdates';

@Component({
  components: {
  },
})
export default class UpdateSnackbar extends Mixins(CheckForUpdates) {

}
